module.exports = __webpack_public_path__ + "img/tired.be5030ca.webp";